var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previous-step__container"},[_c('router-link',{staticClass:"previous-step__link",class:{ 'previous-step__link--hidden': _vm.hidden === true },attrs:{"to":_vm.goToStep}},[_vm._v(_vm._s(_vm.linkText)+"\n    ")])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156096ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/core/components/Navigation.vue
// module id = sIea
// module chunks = 15